// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  min-height: 100vh;
  padding: 120px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.about-text-section {
  animation: slideUp 0.8s ease-out;
}

.about-title {
  font-size: 3.5rem;
  line-height: 1.2;
  margin-bottom: 2rem;
  color: #2c3e50;
}

.highlight {
  background: linear-gradient(120deg, #3498db 0%, #2c3e50 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.about-description {
  font-size: 1.2rem;
  color: #6c757d;
  margin-bottom: 2.5rem;
  line-height: 1.8;
}

.tech-stack {
  margin-bottom: 2.5rem;
}

.tech-stack h3 {
  font-size: 1.2rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.tech-tags {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.tech-tag {
  padding: 0.5rem 1rem;
  background: white;
  border-radius: 25px;
  font-size: 0.9rem;
  color: #3498db;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.tech-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
}

.personal-interests {
  margin-bottom: 2.5rem;
}

.interest-tags {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.interest-tag {
  padding: 0.5rem 1rem;
  background: rgba(52, 152, 219, 0.1);
  border-radius: 25px;
  font-size: 0.9rem;
  color: #2c3e50;
  transition: all 0.3s ease;
}

.interest-tag:hover {
  background: rgba(52, 152, 219, 0.2);
  transform: translateY(-2px);
}

.contact-info {
  margin-bottom: 2rem;
}

.contact-info p {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.contact-info i {
  color: #3498db;
  font-size: 1.2rem;
}

.social-links {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3498db;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #3498db;
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

.social-link i {
  font-size: 1.2rem;
}

.cta-group {
  display: flex;
  gap: 1rem;
}

.cta-button {
  padding: 1rem 2rem;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-button.primary {
  background: #3498db;
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(52,152,219,0.3);
}

.cta-button.secondary {
  background-color: transparent;
  color: #3498db;
  padding: 12px 24px;
  border: 2px solid #3498db;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.cta-button.secondary:hover {
  background-color: #3498db;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

.cta-button:hover {
  transform: translateY(-2px);
}

.profile-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  animation: fadeIn 1s ease-out;
  max-width: 500px;
  margin: 0 auto;
}

.profile-image-container {
  width: 100%;
  height: 400px;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 2rem;
  position: relative;
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  border-radius: 15px;
  transition: transform 0.3s ease;
}

.profile-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  text-align: center;
}

.stat {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #3498db;
}

.stat-label {
  font-size: 0.9rem;
  color: #6c757d;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 968px) {
  .about-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .about-title {
    font-size: 2.5rem;
  }

  .profile-card {
    max-width: 500px;
    margin: 0 auto;
  }
}

.about-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.about-header {
  margin-bottom: 2rem;
}

.name-title {
  font-size: 2.8rem;
  font-weight: 600;
  background: linear-gradient(45deg, #3498db, #2ecc71);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1.5rem;
  position: relative;
  display: inline-block;
  padding-bottom: 0.5rem;
}

.name-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: linear-gradient(45deg, #3498db, #2ecc71);
  border-radius: 2px;
}

/* Animation au survol */
.name-title:hover::after {
  width: 100%;
  transition: width 0.3s ease;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
}

.interests-section {
  margin-bottom: 2rem;
}

.interests-section h2 {
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.interests-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
}

.interest-tag {
  padding: 0.5rem 1rem;
  background-color: #f0f2f5;
  border-radius: 20px;
  font-size: 0.9rem;
  color: #2c3e50;
  transition: all 0.3s ease;
}

.interest-tag:hover {
  background-color: #e2e8f0;
  transform: translateY(-2px);
}

.contact-section {
  margin-bottom: 2rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.contact-item i {
  color: #3498db;
  font-size: 1.2rem;
}

.contact-item a {
  color: #2c3e50;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-item a:hover {
  color: #3498db;
}

.social-links {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3498db;
  transition: all 0.3s ease;
}

.social-link:hover {
  background-color: #3498db;
  color: white;
  transform: translateY(-2px);
}

.cta-buttons {
  display: flex;
  gap: 1rem;
}

.cta-button {
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cta-button.primary {
  background-color: #3498db;
  color: white;
}

.cta-button.secondary {
  border: 2px solid #3498db;
  color: #3498db;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.2);
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.stat-card {
  background-color: white;
  padding: 1.5rem;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  color: #3498db;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: #6c757d;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .about-content {
    grid-template-columns: 1fr;
  }

  .stats-cards {
    margin-top: 2rem;
  }
}

.profile-image:hover {
  transform: scale(1.02);
}

.profile-image-container::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30%;
  background: linear-gradient(to top, rgba(0,0,0,0.1), transparent);
  border-radius: 15px;
  pointer-events: none;
} `, "",{"version":3,"sources":["webpack://./src/components/About/About.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iEAAiE;EACjE,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".about {\n  min-height: 100vh;\n  padding: 120px 0;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n}\n\n.about-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.about-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n.about-text-section {\n  animation: slideUp 0.8s ease-out;\n}\n\n.about-title {\n  font-size: 3.5rem;\n  line-height: 1.2;\n  margin-bottom: 2rem;\n  color: #2c3e50;\n}\n\n.highlight {\n  background: linear-gradient(120deg, #3498db 0%, #2c3e50 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.about-description {\n  font-size: 1.2rem;\n  color: #6c757d;\n  margin-bottom: 2.5rem;\n  line-height: 1.8;\n}\n\n.tech-stack {\n  margin-bottom: 2.5rem;\n}\n\n.tech-stack h3 {\n  font-size: 1.2rem;\n  color: #2c3e50;\n  margin-bottom: 1rem;\n}\n\n.tech-tags {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.tech-tag {\n  padding: 0.5rem 1rem;\n  background: white;\n  border-radius: 25px;\n  font-size: 0.9rem;\n  color: #3498db;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n}\n\n.tech-tag:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0,0,0,0.15);\n}\n\n.personal-interests {\n  margin-bottom: 2.5rem;\n}\n\n.interest-tags {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.interest-tag {\n  padding: 0.5rem 1rem;\n  background: rgba(52, 152, 219, 0.1);\n  border-radius: 25px;\n  font-size: 0.9rem;\n  color: #2c3e50;\n  transition: all 0.3s ease;\n}\n\n.interest-tag:hover {\n  background: rgba(52, 152, 219, 0.2);\n  transform: translateY(-2px);\n}\n\n.contact-info {\n  margin-bottom: 2rem;\n}\n\n.contact-info p {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  color: #6c757d;\n  margin-bottom: 0.5rem;\n}\n\n.contact-info i {\n  color: #3498db;\n  font-size: 1.2rem;\n}\n\n.social-links {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 2.5rem;\n}\n\n.social-link {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #f8f9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #3498db;\n  transition: all 0.3s ease;\n}\n\n.social-link:hover {\n  background: #3498db;\n  color: white;\n  transform: translateY(-3px);\n  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);\n}\n\n.social-link i {\n  font-size: 1.2rem;\n}\n\n.cta-group {\n  display: flex;\n  gap: 1rem;\n}\n\n.cta-button {\n  padding: 1rem 2rem;\n  border-radius: 30px;\n  font-size: 1.1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cta-button.primary {\n  background: #3498db;\n  color: white;\n  border: none;\n  box-shadow: 0 4px 15px rgba(52,152,219,0.3);\n}\n\n.cta-button.secondary {\n  background-color: transparent;\n  color: #3498db;\n  padding: 12px 24px;\n  border: 2px solid #3498db;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.cta-button.secondary:hover {\n  background-color: #3498db;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);\n}\n\n.cta-button:hover {\n  transform: translateY(-2px);\n}\n\n.profile-card {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n  animation: fadeIn 1s ease-out;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.profile-image-container {\n  width: 100%;\n  height: 400px;\n  border-radius: 15px;\n  overflow: hidden;\n  margin-bottom: 2rem;\n  position: relative;\n}\n\n.profile-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  border-radius: 15px;\n  transition: transform 0.3s ease;\n}\n\n.profile-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  text-align: center;\n}\n\n.stat {\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.stat-number {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #3498db;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: #6c757d;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 968px) {\n  .about-content {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n\n  .about-title {\n    font-size: 2.5rem;\n  }\n\n  .profile-card {\n    max-width: 500px;\n    margin: 0 auto;\n  }\n}\n\n.about-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.about-header {\n  margin-bottom: 2rem;\n}\n\n.name-title {\n  font-size: 2.8rem;\n  font-weight: 600;\n  background: linear-gradient(45deg, #3498db, #2ecc71);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 1.5rem;\n  position: relative;\n  display: inline-block;\n  padding-bottom: 0.5rem;\n}\n\n.name-title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 60px;\n  height: 4px;\n  background: linear-gradient(45deg, #3498db, #2ecc71);\n  border-radius: 2px;\n}\n\n/* Animation au survol */\n.name-title:hover::after {\n  width: 100%;\n  transition: width 0.3s ease;\n}\n\n.about-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n}\n\n.interests-section {\n  margin-bottom: 2rem;\n}\n\n.interests-section h2 {\n  font-size: 1.5rem;\n  color: #2c3e50;\n  margin-bottom: 1rem;\n}\n\n.interests-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n}\n\n.interest-tag {\n  padding: 0.5rem 1rem;\n  background-color: #f0f2f5;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  color: #2c3e50;\n  transition: all 0.3s ease;\n}\n\n.interest-tag:hover {\n  background-color: #e2e8f0;\n  transform: translateY(-2px);\n}\n\n.contact-section {\n  margin-bottom: 2rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.contact-item i {\n  color: #3498db;\n  font-size: 1.2rem;\n}\n\n.contact-item a {\n  color: #2c3e50;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.contact-item a:hover {\n  color: #3498db;\n}\n\n.social-links {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.social-link {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #f0f2f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #3498db;\n  transition: all 0.3s ease;\n}\n\n.social-link:hover {\n  background-color: #3498db;\n  color: white;\n  transform: translateY(-2px);\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.cta-button {\n  padding: 0.8rem 1.5rem;\n  border-radius: 25px;\n  text-decoration: none;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.cta-button.primary {\n  background-color: #3498db;\n  color: white;\n}\n\n.cta-button.secondary {\n  border: 2px solid #3498db;\n  color: #3498db;\n}\n\n.cta-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.2);\n}\n\n.stats-cards {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n}\n\n.stat-card {\n  background-color: white;\n  padding: 1.5rem;\n  border-radius: 15px;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.stat-number {\n  display: block;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #3498db;\n  margin-bottom: 0.5rem;\n}\n\n.stat-label {\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .about-content {\n    grid-template-columns: 1fr;\n  }\n\n  .stats-cards {\n    margin-top: 2rem;\n  }\n}\n\n.profile-image:hover {\n  transform: scale(1.02);\n}\n\n.profile-image-container::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 30%;\n  background: linear-gradient(to top, rgba(0,0,0,0.1), transparent);\n  border-radius: 15px;\n  pointer-events: none;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
